export const VendorTypeMap: Record<string, string> = {
  LIEN_HOLDER: 'Lien Holder',
  SERVICE_PROVIDER: 'Service Provider',
  SECONDARY_FIRM: 'Secondary Firm',
};